import { NumberPosition, NumberCounterLayout, NumberType, InputType, Position, UnitEnum, SliderTypeEnum, LinkType, WidthTypeEnum, MenuItemType } from '@teko-builder/types/pb';
import { DSSize, Variant, Alignment, DividerStyleEnum } from '@teko-builder/types/shared';
import { i as img$1 } from './default_image-f8521c37.js';
import dayjs from 'dayjs';

var img = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAANcAAADWCAYAAABCIRcQAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAgvSURBVHgB7d3pcRvJGYDhGVwkyD8uR+AQ7EycwmbgELwZOAOXI7Az8ToDhbBeibiPnW8glFQqgLj6gwTgeapY1EFRJREve3qmp6euGuPx+k91vfxn88M/N29/qICT1XX9S12v/zEY9P7V/vxzWP+tRAVFrNfrn4fD/t/r6XTx7/W6+msFlLJ+eur+sZ5MFusKKKkZvKqfOhWQQlyQRFyQRFyQRFyQRFyQRFyQRFyQRFyQRFyQRFyQRFyQRFyQRFyQRFyQRFyQRFyQRFyQRFyQRFyQRFyQRFyQRFyQRFyQRFyQRFyQRFyQRFyQRFyQRFyQRFyQRFyQRFyQRFyQRFyQRFyQRFyQRFyQRFyQRFyQRFyQRFyQRFyQRFyQRFyQRFyQRFyQRFyQRFyQRFyQRFyQRFyQRFyQRFyQRFyQRFyQRFyQRFyQRFyQRFyQRFyQRFyQRFyQRFyQRFyQRFyQRFyQRFyQpFdxNev1ulqt1s37qqrr5jtbp9O+5z6JK9k2qPFkXs3ni+bHX34vwur1OtXwedC+r5V2V8SVaLlcVaPxrJrNlm1k34pfit+bzcbVoN+rXl76TWTdivsgrgRtNM0oNRpNm8DWR/2Z+PjFx2UT2KB6GvSMYnfACY0Ei8Wyens7PqytOHx8e4uRblFx+8RVWBwKfmrCilDOEYePn5rA4vNw28RVUIQxmc4vDiM+T8zVds3TuB3iKmh7gqKE+Xxp9Lpx4iooYjj3cPBb8XkWC3HdMnEVFCcySh7KxejF7RJXQctV2TnSamXOdcvEVZIW+Iq4Cup2y174dSH5tomroE6nbAzdri/PLfPVKyjWBZYKLEatft+X55b56hUUI81gUGa5Zq8XcVnEe8vEVdjzU6/qXDhXqtvPMzDnunHiKiwODWNl+yVhPD31i4yAcc0tLmzHm6VU1+eWkwTPz/3mmteqmkzm1amv6Qjr5XVw8R3KsbI+/v4Iq+7EIWavehn2jYZXJK4kL8NBO4qNRrNqFSPHgY+P+dqwefE/N3Fdar5YVr99nHz5hXYp1WYh8OuLw81rEVeSeAHHTY/dZtSIGyEn40XzGt+dWIxWz8+9ql/gLuRY1TEZz3b+Xiwqfn5audv5SsSVLF7I8Rb7ZGwW435ZL9hpRqtet9zeGTEyjcfzarpnZf4qDlWni+q1a7+OaxDXlcSLOVZwZF4YjpEp7id7/2MW7aFnnOonl7OFdyJuT3kbTQ+eFWwPG6enn2jhdOK6A+3eG6PjtxaIEc6NmPnEdQcm7Z6Ix9/7FXOv6WxekUtcNywOASOq8WR28p/dt5ci5Yjrhm13mjqnkfizM3c6pxLXjYpR5+On6UVzp7EdplKJ6wZtr2ddelIizjBObUCaRlw3KK5VxYMdSpg2F5UNXjnEdWM217PKHc7F54unr1CeuG7IdifekrtCxeeMQ0Nzr/LEdSPasEY5D2loLyrbxq04cd2IiCrr5EOE68kq5Vm4W1hcO4pT3HFxNxbrxq0ksVD2kgW78blinpW5SWic2Bj0u25HKcjIVdD2uVzbpUjbU+YfP03O3vc9liqVnmftEqf1J1Nzr5LEVdB4svvaU4T1/9/Gn2/7P+3F+zaaX23P+Bi9bKFdjrgKaZcTvTNv2Z7pi5HsmMC286Dp9HoLbNu/c+66VyniKqB96N0Rm9HEqBCBxbKlr+9I3iVijXnWtU0dGhYjrgJiQ5hTzuTFiBQbyOy7vrQd5b7HPVftkqipM4cliKuA6eT0uUp8/KfmRMdox1nA8WT+XZ/NNZm616sEcV1oceKo9bUYtCKkGMXmnw8TY441apc3Vd9NjJhuprycuC7QnmqfXD4vikC3o9j3mGftMp26mfJS4rpAzE9mszLzouVyfZXrWceKw1LPZL6MuM7ULnidzu/2u/tmVL7ff981iOtMm3nJfd8mH4erMaJyHnGdYXsi4t6/q3/Z41Bg5xDXGZbL5cOsIo9/58Ieh2cR14m+zEWqhxCjVyzZ4nTiOlE8d+vQ0qV7s5l7Gb1OJa4TtGsI212XHmsOEqOXmylPJ64TPPJWZPHvdjvKacR1pEeba33LHoenE9eRYu3fo821vuVmytOI60jnrHy/N3EJwh6HxxPXETarMbyo4pB4cw9axRHEdcBmk5kfY6X6j2Dz4DxPRzmGuA7YTOS9mL72yCd2TiGud9z7yvdzxe0oRq/DxPWOR1j5fo44sWOfjcPEtcejrHw/V5zYePRLE4eIa48YteYea7rX5nYUo9d7xLXDZh/CH+eW+x9VXPNyM+V+4tqhHbXsH3FQhOX6337i2iGeVWXUOs7SvGsvce3Q6XSquq44IP6Lej0voX38z+zQb14wg0G/4n2dTl31+57ntY+H3+3xMuw335nX1tLtEKN6PMzv9WXQvBfXPuLaI74rv74+VcMmslV7bkNhW/HEzEuelPkoxHVAzL86XkecwcsGkogLkogLkogLkogLkogLkogLkogLkogLkogLkogLkogLkogLkogLkogLkogLkogLkogLkogLkogLkogLkogLkogLkogLkogLkogLkogLkogLkogLkogLkogLkogLkogLkogLkogLkogLkogLkogLkogLkogLkogLkogLkogLkogLkogLkogLkogLkogLkogLkogLkogLkogLkogLkogLkogLkogLkogLkogLkogLkogLkogLkogLkogLkogLkogLkogLkogLkkRcv1ZAUatV9WvE9UsFFNXpzP/XWa+7P1VGLyimruufh8Phh85wWH9oAvtL82v/qYAL1B+at789PXV/jp/9DmGKEE6rMfdLAAAAAElFTkSuQmCC";

const DEFAULT_STYLE = {
    duration: 0,
    delay: 0,
    backgroundColor: '#efefef',
    foregroundColor: '#4caf50ff',
    textStyle: {
        fontSize: 16,
    },
    numberStyle: {
        fontSize: 32,
    },
};
const DEFAULT_BAR_STYLE = {
    barStyle: {
        numberPosition: NumberPosition.inside,
        height: 42,
    },
    textStyle: Object.assign(Object.assign({}, DEFAULT_STYLE.textStyle), { textAlign: 'left' }),
    numberStyle: Object.assign(Object.assign({}, DEFAULT_STYLE.numberStyle), { textAlign: 'right', lineHeight: 42, color: '#fff' }),
};
const DEFAULT_CIRCLE_STYLE = {
    circleStyle: {
        size: 250,
        strokeSize: 10,
    },
    textStyle: Object.assign(Object.assign({}, DEFAULT_STYLE.textStyle), { textAlign: 'center' }),
    numberStyle: Object.assign(Object.assign({}, DEFAULT_STYLE.numberStyle), { textAlign: 'center', fontSize: 40 }),
};
const DEFAULT_NUMBER_STYLE = {
    textStyle: Object.assign(Object.assign({}, DEFAULT_STYLE.textStyle), { textAlign: 'center' }),
    numberStyle: Object.assign(Object.assign({}, DEFAULT_STYLE.numberStyle), { textAlign: 'center' }),
};
const DEFAULT_NUMBER_COUNTER = Object.assign(Object.assign({ textBefore: 'Số lượng đơn thành công', layout: NumberCounterLayout.bar, number: 89, numberType: NumberType.percent }, DEFAULT_STYLE), DEFAULT_BAR_STYLE);

const DEFAULT_SECTION_MARGIN_STYLE = {
    bottom: 16,
};
const DEFAULT_FORM_STYLE = {
    formItem: {
        columnWidth: 100,
        additionOptions: {
            textarea: {
                rows: 4,
            },
        },
    },
    columnGap: 12,
    rowGap: 24,
};
const DEFAULT_FORM = {
    name: 'Form',
    formItems: [
        {
            type: InputType.text,
            name: 'name',
            placeholder: 'Nhập tên',
            label: 'Tên',
        },
        {
            type: InputType.email,
            name: 'email',
            placeholder: 'Nhập email',
            label: 'Email',
        },
        {
            type: InputType.textarea,
            name: 'message',
            placeholder: 'Nhập thông báo',
            label: 'Thông báo',
        },
    ],
    showLabel: true,
    submitWithParams: false,
    inputSize: DSSize.default,
    labelColor: 'rgba(0, 0, 0, 1)',
    errorColor: 'rgba(255, 77, 79, 1)',
    submitButton: {
        variant: Variant.primary,
        size: DSSize.default,
        text: 'Button',
        alignment: Alignment.justify,
        iconConfig: {
            position: Position.front,
            spacing: 8,
            show: true,
            icon: {
                size: 24,
            },
        },
        commonStyle: {
            padding: {
                bottom: 8,
                top: 8,
                left: 16,
                right: 16,
                unit: UnitEnum.pixel,
            },
            width: '100%',
            color: 'rgba(255, 255, 255, 1)',
            backgroundColor: 'rgba(37, 141, 255, 1)',
            hover: {
                color: 'rgba(255, 255, 255, 1)',
                backgroundColor: 'rgba(33, 127, 230, 1)',
            },
        },
    },
    responsePopup: [],
    sheetResponsePopup: undefined,
};
const DEFAULT_HEADING = {
    text: '<h2>Heading 2</h2>',
    htmlTag: 'h2',
    content: 'Heading 2',
};
const DEFAULT_PARAGRAPH = {
    text: '<p><span style="font-size:14px;">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo.</span></p>',
};
const DEFAULT_BUTTON = {
    variant: Variant.primary,
    text: 'Bấm vào đây',
    size: DSSize.default,
    alignment: Alignment.left,
    iconConfig: {
        position: Position.front,
        spacing: 8,
        show: true,
        icon: {
            size: 24,
        },
    },
};
const DEFAULT_BUTTON_STYLE = {
    padding: {
        bottom: 8,
        top: 8,
        left: 16,
        right: 16,
        unit: UnitEnum.pixel,
    },
    backgroundColor: 'rgba(37, 141, 255, 1)',
    color: 'rgba(255, 255, 255, 1)',
    hover: {
        color: 'rgba(255, 255, 255, 1)',
        backgroundColor: 'rgba(33, 127, 230, 1)',
    },
};
const DEFAULT_YOUTUBE = {
    link: '',
    autoplay: false,
};
const DEFAULT_SLIDER = {
    commonStyle: {
        height: 350,
    },
    type: SliderTypeEnum.image,
    items: [
        {
            src: 'https://lh3.googleusercontent.com/Jj-xgwH9NZCn-WFxpJlkBnfAhTJ5smgyxBUjX9QyUR2b-gSHqHjG3XOIUO7yVAcOmV4dQsNA1KvLDaqZEP9hI7Cq-n6ty_4BHg=w1232-rw',
            googleImageParams: {
                width: 1200,
            },
        },
        {
            src: 'https://lh3.googleusercontent.com/_2Arqz2Hu80YPgo7TeHDH0smg0jMPimHIuLRZdMHq7Jb4fg7gfnxJofMmIBD8K-b5bPmhEzuLa2hj_lzafkxiSg0zeh8-74VXQ=w1232-rw',
            googleImageParams: {
                width: 1200,
            },
        },
        {
            src: 'https://lh3.googleusercontent.com/Eci1c3zs_AgF0kahUvV-mjfFGvODH5HaT4bLmeui9f2vF9cZTYIscS7spiQBTXWUPLmH86ysCLtxgCmTYs40gRhsnriBVaf_OA=w1232-rw',
            googleImageParams: {
                width: 1200,
            },
        },
    ],
    slidesPerView: 1,
    slidesPerColumn: 1,
    navigation: true,
    navigationStyle: undefined,
    pagination: true,
    paginationStyle: undefined,
    paginationColor: 'rgba(37, 141, 255, 1)',
    autoplay: false,
    loop: false,
    spaceBetween: 12,
    speed: 3000,
    pauseOnMouseEnter: true,
    virtual: false,
    crop: true,
};
const DEFAULT_SLIDER_V2 = {
    commonStyle: {
        height: 350,
    },
    items: [
        {
            src: 'https://lh3.googleusercontent.com/Jj-xgwH9NZCn-WFxpJlkBnfAhTJ5smgyxBUjX9QyUR2b-gSHqHjG3XOIUO7yVAcOmV4dQsNA1KvLDaqZEP9hI7Cq-n6ty_4BHg=w1232-rw',
            link: {
                href: 'https://www.phongvu.vn/',
                linkType: LinkType.external,
                target: '_blank',
            },
        },
        {
            src: 'https://lh3.googleusercontent.com/_2Arqz2Hu80YPgo7TeHDH0smg0jMPimHIuLRZdMHq7Jb4fg7gfnxJofMmIBD8K-b5bPmhEzuLa2hj_lzafkxiSg0zeh8-74VXQ=w1232-rw',
            link: {
                href: 'https://www.phongvu.vn/',
                linkType: LinkType.external,
                target: '_blank',
            },
        },
        {
            src: 'https://lh3.googleusercontent.com/Eci1c3zs_AgF0kahUvV-mjfFGvODH5HaT4bLmeui9f2vF9cZTYIscS7spiQBTXWUPLmH86ysCLtxgCmTYs40gRhsnriBVaf_OA=w1232-rw',
        },
    ],
    paginationColor: 'rgba(37, 141, 255, 1)',
    paginationPosition: 'inside',
};
const DEFAULT_DIVIDER_STYLE = {
    color: 'rgba(0 ,0 ,0)',
    width: '100%',
};
const DEFAULT_DIVIDER = {
    style: DividerStyleEnum.solid,
    weight: {
        unit: UnitEnum.pixel,
        size: 1,
    },
    gap: {
        unit: UnitEnum.pixel,
        size: 14,
    },
    iconConfig: {
        icon: {
            size: 24,
        },
    },
};
const DEFAULT_OK_BUTTON = {
    hideAfterClick: true,
    size: DSSize.default,
    text: 'Xác nhận',
    alignment: Alignment.center,
    iconConfig: {
        position: Position.front,
        spacing: 8,
        show: true,
        icon: {
            size: 24,
        },
    },
    commonStyle: {
        padding: {
            bottom: 8,
            top: 8,
            left: 16,
            right: 16,
            unit: UnitEnum.pixel,
        },
        border: {
            borderRadius: 8,
        },
        color: 'rgba(255, 255, 255, 1)',
        backgroundColor: 'rgba(37, 141, 255, 1)',
        hover: {
            color: 'rgba(255, 255, 255, 1)',
            backgroundColor: 'rgba(33, 127, 230, 1)',
        },
    },
};
const DEFAULT_CANCEL_BUTTON = {
    hideAfterClick: true,
    size: DSSize.default,
    text: 'Hủy',
    alignment: Alignment.center,
    iconConfig: {
        position: Position.front,
        spacing: 8,
        show: true,
        icon: {
            size: 24,
        },
    },
    commonStyle: {
        padding: {
            bottom: 8,
            top: 8,
            left: 16,
            right: 16,
            unit: UnitEnum.pixel,
        },
        border: {
            borderRadius: 8,
            borderWidth: 1,
            borderColor: 'rgba(188, 191, 214, 1)',
            borderStyle: 'solid',
        },
        color: 'rgba(130, 134, 158, 1)',
        backgroundColor: 'rgba(255, 255, 255, 1)',
        hover: {
            color: 'rgba(130, 134, 158, 1)',
            borderColor: 'rgba(130, 134, 158, 1)',
        },
    },
};
const DEFAULT_POPUP = {
    show: false,
    showCloseBtn: true,
    title: '<h4 style="text-align:center">Thông báo</h4>',
    content: '<p><span style="font-size:14px;">Bạn cần gia hạn gói cước!</span></p>',
    popupButton: [DEFAULT_CANCEL_BUTTON, DEFAULT_OK_BUTTON],
};
const DEFAULT_ICON = {
    name: 'AccountOutlined',
    size: 24,
};
const DEFAULT_HEADER = {
    header: {
        alignment: 'right',
        widthType: WidthTypeEnum.full,
        toggle: {
            icon: {
                color: 'rgba(0, 0, 0, 1)',
                size: 24,
            },
        },
        commonStyle: {
            backgroundColor: 'rgba(255, 255, 255, 1)',
            minHeight: 80,
            padding: {
                left: 16,
                right: 16,
            },
            position: 'relative',
        },
    },
    logo: {
        alignment: 'left',
        commonStyle: {
            height: 56,
        },
    },
    link: {
        type: MenuItemType.link,
        itemData: {
            text: '<h4>Home</h4>',
        },
    },
    button: {
        type: MenuItemType.button,
        itemData: {
            text: 'Download',
            buttonStyle: {
                backgroundColor: 'rgba(37, 141, 255, 1)',
                color: 'rgba(255, 255, 255, 1)',
                height: 32,
                minWidth: 120,
            },
            iconConfig: {
                position: 'left',
                spacing: 8,
                show: true,
                icon: {
                    size: 24,
                },
            },
        },
    },
};
const DEFAULT_COUNTDOWN = {
    countdownType: 'due',
    due: dayjs().startOf('day').format('DD/MM/YYYY HH:mm'),
    showDays: true,
    showHours: true,
    showMinutes: true,
    showSeconds: true,
    showLabel: true,
    labelDays: 'Ngày',
    labelHours: 'Giờ',
    labelMinutes: 'Phút',
    labelSeconds: 'Giây',
    countdownStyle: {
        elementGap: 20,
        labelGap: 0,
        align: Alignment.left,
        layout: 'vertical',
        labelPosition: 'baseline',
        digitStyle: {
            fontSize: 40,
        },
        labelStyle: {
            textAlign: 'center',
        },
        timeUnitStyle: {
            padding: {
                top: 10,
                bottom: 10,
                left: 10,
                right: 10,
            },
        },
    },
};
const DEFAULT_LIST_DIVIDER = {
    style: DividerStyleEnum.solid,
    gap: {
        size: 0,
        unit: UnitEnum.pixel,
    },
    weight: {
        size: 1,
        unit: UnitEnum.pixel,
    },
};
const DEFAULT_LIST_DIVIDER_STYLE = {
    color: '#747483',
};
const DEFAULT_LIST = {
    list: {
        icon: {
            name: 'RightLineOutlined',
        },
        itemStyle: {
            columnGap: 8,
        },
    },
    listItem: {},
    listItemIcon: {},
    listItemContent: {
        text: 'This is 1 line of list',
    },
};
const DEFAULT_PRODUCT_CARD = {
    image: { src: img },
    title: {
        text: '<p><strong>Tên sản phẩm</strong></p>',
        commonStyle: {
            fontSize: 16,
        },
    },
    spacer: { height: 15 },
    newPrice: {
        text: '<p><strong>99.999 đ</strong></p>',
        commonStyle: {
            color: '#DF2C3B',
            fontSize: 14,
            margin: { top: 5, bottom: 5 },
        },
    },
    cardStyle: {
        padding: { top: 16, bottom: 16, left: 16, right: 16 },
        borderRadius: 10,
        backgroundColor: '#ffffff',
    },
};
const DEFAULT_TESTIMONIAL_CAROUSEL = {
    items: Array(3).fill({
        content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo.',
        image: {
            src: img$1,
        },
        name: 'Peter Pan',
        title: 'Customer',
    }),
    imageStyle: {
        width: 56,
        border: { borderRadius: 28 },
    },
    contentStyle: {
        fontStyle: 'italic',
        fontSize: 18,
        textAlign: 'center',
    },
    nameStyle: {
        fontWeight: 'bold',
        fontSize: 14,
        textAlign: 'center',
    },
    titleStyle: {
        color: 'rgba(37, 141, 255, 1)',
        textAlign: 'center',
    },
    slidesPerView: 1,
    slidesPerColumn: 1,
    navigation: true,
    navigationStyle: undefined,
    pagination: true,
    paginationStyle: undefined,
    paginationColor: 'rgba(37, 141, 255, 1)',
    paginationPosition: 'outside',
    autoplay: false,
    loop: true,
    spaceBetween: 12,
    speed: 3000,
    pauseOnMouseEnter: true,
    virtual: false,
    alignment: 'center',
    layout: 'imageAbove',
    skin: 'default',
    width: 70,
    bubbleStyle: {
        backgroundColor: 'rgba(239, 239, 239, 1)',
        padding: { bottom: 16, top: 16, left: 16, right: 16, unit: UnitEnum.pixel },
    },
};
const DEFAULT_ACCORDION = {
    accordion: {
        icon: {
            name: 'AntdDownOutlined',
            activeName: 'AntdUpOutlined',
            size: 18,
            color: '#000000',
            align: Alignment.right,
        },
        headerStyle: {
            padding: { top: 12, right: 16, bottom: 12, left: 16 },
            columnGap: 8,
        },
        contentStyle: {
            padding: { top: 12, right: 16, bottom: 12, left: 16 },
        },
        contentAlign: Alignment.left,
        duration: 0.3,
        commonStyle: {
            rowGap: 8,
        },
    },
    accordionContent: {},
    accordionItem: {
        title: '<h5>Item 1</h5>',
    },
};
const DEFAULT_BOX = {
    commonStyle: { padding: { top: 16, right: 16, bottom: 16, left: 16 } },
};

export { DEFAULT_ACCORDION, DEFAULT_BAR_STYLE, DEFAULT_BOX, DEFAULT_BUTTON, DEFAULT_BUTTON_STYLE, DEFAULT_CANCEL_BUTTON, DEFAULT_CIRCLE_STYLE, DEFAULT_COUNTDOWN, DEFAULT_DIVIDER, DEFAULT_DIVIDER_STYLE, DEFAULT_FORM, DEFAULT_FORM_STYLE, DEFAULT_HEADER, DEFAULT_HEADING, DEFAULT_ICON, DEFAULT_LIST, DEFAULT_LIST_DIVIDER, DEFAULT_LIST_DIVIDER_STYLE, DEFAULT_NUMBER_COUNTER, DEFAULT_NUMBER_STYLE, DEFAULT_OK_BUTTON, DEFAULT_PARAGRAPH, DEFAULT_POPUP, DEFAULT_PRODUCT_CARD, DEFAULT_SECTION_MARGIN_STYLE, DEFAULT_SLIDER, DEFAULT_SLIDER_V2, DEFAULT_STYLE, DEFAULT_TESTIMONIAL_CAROUSEL, DEFAULT_YOUTUBE };
